export const contentData = {
  spanish:{
    layout:{
      title:'Editar Hospital',
      navigation:[
        {name:'Catálogos',path:'/catalogs'},
        {name:'Hospitales',path:'/catalogs/hospitals'},
        {name:'Detalles',path:'/catalogs/hospitals/:id'},
        {name:'Editar',path:'/catalogs/hospitals/:id/edit'}
        
      ],
      menu2:[
        {id:0, label:'Mis datos'},
        {id:1, label:'Horario'},
      ],
    },
  }
}